import { Suspense } from 'react'
import { Link } from 'react-router'

import { AnalyticsSelectors } from '@/features/analytics'
import { useInviteLinksTimeSelectors } from '@/features/analytics/invite-links/hooks'
import { useInviteLinksStore } from '@/features/analytics/model'
import { Title } from '@/shared/ui'

import { InviteLinksGroupsSitesTable } from './InviteLinksGroupsSitesTable'
import { CreateGroupSites } from './CreateGroupSites'

import './inviteLinksWidget.scss'
import { GroupsSiteFormattedRowType } from '../hooks/useGroupsSitesFormattedRows'
import {
    useActiveWorkspace,
    workspacePath,
} from '@/true-fsd/data/advertiser-account'

export type InviteLinksGroupsSitesWidgetProps = {
    siteId: number
}
export const InviteLinksGroupsSitesWidget = ({
    siteId,
}: InviteLinksGroupsSitesWidgetProps) => {
    const {
        startDateGroup,
        endDateGroup,
        usersSortInvite,
        subscriberStatusSortGroup,
        detalizationSortGroup,
        lineDateGroup,
        selectedGroups,
        toggleSelectedGroup,
        setLineDateGroup,
        setStartDateGroup,
        setEndDateGroup,
        setDetalizationSortGroup,
        setUsersSortGroup,
        setSubscriberStatusSortGroup,
    } = useInviteLinksStore()

    const { handleLineDateSelect, handleDateChange } =
        useInviteLinksTimeSelectors({
            setLineDate: setLineDateGroup,
            setStartDate: setStartDateGroup,
            setEndDate: setEndDateGroup,
        })

    const handleRowSelect = (row: GroupsSiteFormattedRowType) => {
        toggleSelectedGroup(siteId, row.id)
    }

    const isRowSelected = (row: GroupsSiteFormattedRowType) => {
        return (selectedGroups[siteId] || []).includes(row.id)
    }

    const { activeWorkspace } = useActiveWorkspace()

    return (
        <div className="invite-links-groups-widget">
            <div>
                <Title className="title">Ссылки</Title>
                <p className="invite-links-groups-widget__link">
                    <Link
                        to={workspacePath(activeWorkspace, `analytics/links`)}
                        className="campaigns-link"
                    >
                        Группы
                    </Link>{' '}
                    / Все
                </p>
            </div>
            <Suspense fallback={<div>Loading...</div>}>
                <>
                    <AnalyticsSelectors
                        lineDate={lineDateGroup}
                        detalization={detalizationSortGroup}
                        users={usersSortInvite}
                        subscribers={subscriberStatusSortGroup}
                        datePicker={{
                            startDate: startDateGroup,
                            endDate: endDateGroup,
                        }}
                        onLineDateSelect={handleLineDateSelect}
                        onDetalizationSelect={setDetalizationSortGroup}
                        onUsersSelect={setUsersSortGroup}
                        onSubscribersSelect={setSubscriberStatusSortGroup}
                        onDateChange={{
                            onFromDateChange: (date) =>
                                handleDateChange(date, endDateGroup),
                            onToDateChange: (date) =>
                                handleDateChange(startDateGroup, date),
                        }}
                        mode="InviteLinks"
                    />
                    {/* <InviteLinksGroupsChart /> */}
                    <CreateGroupSites siteId={siteId} />
                    <InviteLinksGroupsSitesTable
                        className={'grow'}
                        siteId={siteId}
                        handleCheckboxChange={handleRowSelect}
                        isRowSelected={isRowSelected}
                    />
                </>
            </Suspense>
        </div>
    )
}
